export default __webpack_public_path__ + "b861d8868b4918ba57b5cfa78c54f154.svg";